/**
 * Returns the Data Studio base URL based on the current environment
 * - Production: https://studio.hginsights.com
 * - Dev/Staging: https://studio-staging.hginsights.info
 */
export const getStudioBaseUrl = (): string =>
  ENVIRONMENT === 'prod'
    ? 'https://studio.hginsights.com'
    : 'https://studio-staging.hginsights.info';
